import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

Vue.config.productionTip = false
Vue.prototype.themeName = "light";
if(localStorage.themeName != undefined){
	Vue.prototype.themeName = localStorage.themeName
}

 
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
